export default {
    common: {
        ok: 'ОК',
        cancel: 'Отмена',
        save: 'Сохранить',
        delete: 'Удалить',
        edit: 'Изменить',
        close: 'Закрыть',
        confirm: 'Подтвердить',
        back: 'Назад',
        next: 'Далее',
        apply: 'Применить',
        done: 'Готово',
        loading: 'Загрузка...',
        error: 'Ошибка',
        success: 'Успешно',
        warning: 'Предупреждение',
        info: 'Информация'
    },
    navbar: {
        home: 'Главная',
        history: 'История',
        settings: 'Настройки',
        profile: 'Профиль',
        vacation: 'Отпуск',
        scanner: {
            checkIn: 'Вход',
            bleCheckIn: 'BLE-вход',
            checkingLocation: 'Проверка местоположения...',
            locationRequired: 'Требуется местоположение'
        }
    },
    settings: {
        title: 'Настройки',
        notifications: {
            title: 'Уведомления',
            checkInReminders: 'Напоминания о входе',
            checkInRemindersDesc: 'Напоминать об отметке до начала работы',
            checkOutReminders: 'Напоминания о выходе',
            checkOutRemindersDesc: 'Напоминать об отметке после окончания работы',
            reminderTime: 'Время напоминания',
            reminderTimeDesc: 'За сколько заранее отправлять напоминания',
            updated: {
                checkIn: 'Напоминания о входе обновлены',
                checkOut: 'Напоминания о выходе обновлены',
                time: 'Время напоминания обновлено'
            }
        },
        bleAttendance: {
            title: 'Bluetooth посещаемость',
            enableLabel: 'Включить BLE посещаемость',
            enableDesc: 'Автоматическое обнаружение Bluetooth-устройства для отметки посещаемости',
            enabled: 'Bluetooth посещаемость включена',
            disabled: 'Bluetooth посещаемость отключена',
            permissionDenied: 'Разрешения Bluetooth отклонены. Включите в настройках устройства.',
            updateFailed: 'Не удалось обновить настройку Bluetooth'
        },
        reminder: {
            minutesBefore: 'Минут до',
            minutesAfter: 'Минут после',
            minutes: {
                one: '1 минута',
                other: '{count} минут'
            }
        },
        appearance: {
            title: 'Внешний вид',
            theme: 'Тема',
            themeDesc: 'Выберите предпочитаемую цветовую тему',
            themeOptions: {
                light: 'Светлая',
                dark: 'Тёмная',
                auto: 'Авто (Система)'
            },
            themeChanged: 'Тема изменена на {theme}'
        },
        language: {
            title: 'Язык',
            language: 'Язык',
            languageDesc: 'Выберите предпочитаемый язык',
            languageChanged: 'Язык изменён на {language}'
        },
        profile: {
            title: 'Профиль',
            workerId: 'ID работника',
            name: 'Имя',
            lastSync: 'Последняя синхронизация',
            notAssigned: 'Не назначено',
            unknown: 'Неизвестно',
            never: 'Никогда'
        },
        reminderTimeOptions: {
            minutes5: '5 минут',
            minutes10: '10 минут',
            minutes15: '15 минут',
            minutes30: '30 минут',
            hour1: '1 час'
        }
    },
    dashboard: {
        title: 'Панель',
        checkIn: 'Вход',
        checkOut: 'Выход',
        welcome: 'Добро пожаловать',
        currentStatus: 'Текущий статус',
        todayAttendance: 'Посещаемость сегодня',
        totalDays: 'Всего дней',
        comingSoon: 'Скоро',
        duration: 'Длительность',
        shortDuration: 'Мало',
        onTrack: 'В норме',
        working: 'Рабочее время',
        durationComplete: 'Выполнено',
        notCheckedIn: 'Не отмечено',
        notYet: 'Пока нет',
        completed: 'Завершено',
        onTime: 'Вовремя',
        late: 'Опоздание',
        early: 'Раньше',
        missingCheckOut: 'Нет отметки выхода',
        manualEntry: 'Ручной ввод',
        vacationUsed: 'Использовано',
        vacationLeft: 'Осталось',
        attendanceRegistered: 'Отметка зарегистрирована',
        qrValidated: 'QR-код подтверждён',
        bleValidated: 'Bluetooth подтверждён',
        processingBleCheckin: 'Обработка входа через Bluetooth...',
        logout: {
            confirm: 'Подтвердите выход',
            message:
                'Вы уверены, что хотите выйти? Нужно будет заново назначить профиль работника.',
            cancel: 'Отмена',
            button: 'Выйти'
        }
    },
    history: {
        title: 'История',
        noRecords: 'Записи посещаемости не найдены',
        checkInTime: 'Вход',
        checkOutTime: 'Выход',
        labels: {
            duration: 'Длительность',
            location: 'Местоположение',
            qrCode: 'QR-код',
            geofence: 'Геозона'
        },
        viewToggle: {
            calendar: 'Календарь',
            list: 'Список'
        },
        loading: 'Загрузка истории посещаемости...',
        error: 'Не удалось загрузить историю посещаемости. Попробуйте снова.',
        retry: 'Повторить',
        emptyState: 'Нет записей за этот период.',
        validated: 'Подтверждено',
        notValidated: 'Не подтверждено',
        calendar: {
            prevMonth: 'Предыдущий месяц',
            nextMonth: 'Следующий месяц',
            viewDetailsAtTime: 'Просмотреть детали для {time}'
        },
        status: {
            holiday: 'Праздник',
            absence: 'Отсутствие'
        }
    },
    scanner: {
        title: 'QR-сканер',
        scanning: 'Сканирование...',
        scanSuccess: 'Сканирование успешно',
        scanError: 'Ошибка сканирования'
    },
    profile: {
        title: 'Профиль',
        assignWorker: 'Назначить работника'
    },
    admin: {
        title: 'Админ-панель',
        accessDenied: 'Доступ запрещён',
        subtitle: 'Административный доступ — используйте с осторожностью',
        banner: {
            title: 'АКТИВЕН РЕЖИМ АДМИНИСТРАТОРА',
            description: 'Включены настройки отладки и административные функции. Используйте с осторожностью.'
        },
        debug: {
            banner: {
                title: 'ТОЛЬКО ДЛЯ ТЕСТИРОВАНИЯ',
                desc: 'Режимы отладки обходят проверки безопасности. Отключите перед продакшеном.'
            },
            bypass: {
                title: 'Обойти проверку геозоны',
                desc: 'Разрешить вход/выход из любого местоположения'
            },
            staticQr: {
                title: 'Разрешить статичный QR-код',
                desc: 'Принимать предопределённый тестовый QR-код (никогда не истекает)'
            },
            lastModified: 'Последнее изменение:',
            time: {
                never: 'Никогда',
                justNow: 'Только что',
                minutes: {
                    one: '1 минуту назад',
                    other: '{count} минут назад'
                },
                hours: {
                    one: '1 час назад',
                    other: '{count} часов назад'
                }
            }
        },
        prompt: {
            title: 'Аутентификация администратора',
            description: 'Введите пароль администратора, чтобы продолжить',
            passwordLabel: 'Пароль',
            passwordPlaceholder: 'Введите пароль администратора',
            unlock: 'Разблокировать панель',
            accessGranted: 'Доступ администратора предоставлен',
            incorrectPassword: 'Неверный пароль',
            authFailed: 'Сбой аутентификации',
            lockedTitle: 'Учетная запись заблокирована',
            attemptsRemaining: 'Осталось попыток: {count}',
            errors: {
                required: 'Требуется пароль',
                lockedOut: 'Слишком много неудачных попыток. Повторите через {minutes} мин.'
            }
        },
        alerts: {
            exit: {
                header: 'Выйти из режима администратора',
                message:
                    'Вы уверены, что хотите выйти из режима администратора? Чтобы войти снова, понадобится жест.',
                confirm: 'Выйти'
            },
            forget: {
                header: 'Забыть работника',
                message:
                    'Вы уверены, что хотите забыть этого работника? Все локальные данные будут очищены и приложение вернётся в исходное состояние. Это действие нельзя отменить.',
                confirm: 'Забыть работника'
            },
            resetBundle: {
                header: 'Сбросить пакет приложения',
                message: 'Приложение будет сброшено до встроенной версии. Приложение закроется и его нужно будет открыть вручную.',
                confirm: 'Сбросить и закрыть'
            }
        },
        cards: {
            manualRecords: {
                title: 'Ручные записи',
                value: 'Управление присутствием',
                status: 'Создание, редактирование и удаление записей',
                open: 'Открыть записи'
            },
            logs: {
                title: 'Системные логи',
                value: 'Активность и безопасность',
                status: 'Журналы активности и мониторинг безопасности',
                open: 'Открыть логи'
            },
            worker: {
                title: 'Текущий работник',
                noWorker: 'Работник не назначен',
                id: 'ID',
                assignToContinue: 'Назначьте работника для продолжения',
                forget: 'Забыть работника',
                workerIdMissing: 'ID работника не найден',
                forgotten: 'Работник забыт. Все локальные данные очищены.'
            },
            settings: {
                title: 'Настройки',
                value: 'Конфигурация',
                status: 'Настройки приложения и параметры отладки',
                open: 'Открыть настройки'
            },
            system: {
                title: 'Система',
                value: 'Обновить',
                status: 'Данные и состояние системы',
                refreshButton: 'Обновить данные',
                refreshing: 'Обновление всех данных...',
                refreshed: 'Все данные успешно обновлены!',
            refreshFailed: 'Не удалось обновить данные',
            checkSyncStatus: 'Проверить статус синхронизации',
            forceMarkPending: 'Принудительно пометить как ожидающее',
            toasts: {
                syncStatus: 'Сегодня: {today} (в ожидании: {pendingToday})\nВсего в ожидании: {totalPending}',
                syncStatusFailed: 'Не удалось проверить статус синхронизации',
                noRecordsToday: 'На сегодня записей не найдено',
                markedPending: 'Помечено записей: {count} как в ожидании. Используйте «Обновить данные» для синхронизации.',
                markPendingFailed: 'Не удалось пометить записи как в ожидании'
            }
            },
            schedule: {
                title: 'График работы',
                type: 'Тип',
                duration: 'Длительность',
                checkIn: 'Вход',
                checkOut: 'Выход',
                before: 'до',
                after: 'после',
                maxOffsetStart: 'Макс. сдвиг начала',
                minOffsetEnd: 'Мин. сдвиг конца',
                days: 'Дни'
            },
            notifications: {
                title: 'Уведомления',
                value: 'Тест',
                status: 'Отправить тестовое уведомление',
                send: 'Отправить тест',
                sent: 'Тестовое уведомление отправлено! Проверьте панель уведомлений.',
                sendFailed: 'Не удалось отправить тестовое уведомление'
            },
            session: {
                started: 'Сессия администратора начата'
            }
        },
        geofence: {
            title: 'Просмотр геозоны',
            status: {
                inside: 'Внутри геозоны',
                outside: 'Вне геозоны',
                unknown: 'Неизвестно'
            },
            accuracy: {
                label: 'Точность GPS',
                meters: 'метров',
                na: 'нет'
            },
            error: 'Ошибка:',
            legend: {
                title: 'Легенда',
                boundary: 'Граница геозоны',
                currentLocation: 'Текущее местоположение'
            }
        },
        totp: {
            title: 'Настройка секрета TOTP',
            subtitle: 'Настройте общий секрет для проверки QR-кода',
            status: {
                status: 'Статус:',
                configured: 'Настроено',
                notConfigured: 'Не настроено',
                lastSynced: 'Последняя синхронизация:',
                secretLength: 'Длина секрета:',
                characters: '{chars} символов'
            },
            info: {
                howTo: 'Как настроить:',
                scanTitle: 'Сканируйте QR-код:',
                scanDesc: 'Используйте сканер ниже, чтобы сканировать из приложения Generator',
                manualTitle: 'Ручной ввод:',
                manualDesc: 'Введите секрет Base32 напрямую',
                note: 'Обе программы должны использовать один и тот же секрет для корректной верификации.'
            },
            scan: {
                title: 'Сканировать QR-код из Generator',
                desc: 'Сканируйте любой QR-код из приложения Generator, чтобы автоматически извлечь и сохранить секрет.',
                open: 'Открыть сканер QR',
                modalTitle: 'Сканировать QR-код',
                instructions: 'Поместите QR-код из приложения Generator в рамку'
            },
            manual: {
                title: 'Ручной ввод секрета',
                placeholder: 'Введите секрет Base32 (например, JBSWY3DPEHPK3PXP)'
            },
            validation: {
                invalidFormat: 'Неверный формат. Используйте только символы A-Z и 2-7.',
                tooShort: 'Секрет слишком короткий. Рекомендуется минимум 16 символов.',
                valid: 'Допустимый формат Base32'
            },
            actions: {
                save: 'Сохранить секрет',
                update: 'Обновить секрет',
                clear: 'Очистить секрет'
            },
            viewCurrent: 'Показать текущий секрет',
            modal: {
                currentTitle: 'Текущий секрет TOTP',
                keepSecure: 'Храните этот секрет в безопасности! Имея его, можно генерировать действительные токены.',
                copy: 'Копировать в буфер'
            },
            test: {
                title: 'Тест генерации TOTP',
                desc: 'Сгенерируйте токен, чтобы убедиться, что секрет работает корректно. Токен должен совпадать с тем, что в приложении Generator.',
                generate: 'Сгенерировать тестовый токен',
                currentToken: 'Текущий токен:',
                validFor: 'Действителен {seconds}с'
            },
            alert: {
                clear: {
                    header: 'Очистить секрет TOTP?',
                    message: 'Это удалит сохранённый секрет. Вам нужно будет заново настроить его, отсканировав QR-код или введя вручную.',
                    confirm: 'Очистить'
                }
            },
            toast: {
                saved: 'Секрет TOTP успешно сохранён',
                saveFailed: 'Не удалось сохранить секрет',
                cleared: 'Секрет TOTP очищен',
                clearFailed: 'Не удалось очистить секрет',
                loadFailed: 'Не удалось загрузить секрет',
                copySuccess: 'Секрет скопирован в буфер обмена',
                copyFailed: 'Не удалось скопировать секрет',
                openScannerFailed: 'Не удалось открыть сканер',
                generateFailed: 'Не удалось сгенерировать токен',
                noSecret: 'Секрет не настроен',
                scanSaved: 'Секрет отсканирован и сохранён ({length} символов)',
                invalidQR: 'Неверный формат QR-кода',
                scanFailed: 'Сканирование не удалось: {error}'
            }
        },
        manualRecords: {
            pageTitle: 'Управление ручными записями',
            labels: {
                worker: 'Работник',
                month: 'Месяц'
            },
            actions: {
                create: 'Создать ручную запись'
            },
            loading: 'Загрузка записей...',
            empty: 'За этот месяц записи посещаемости отсутствуют.',
            status: {
                inProgress: 'В процессе',
                checkedIn: 'Вход',
                checkedOut: 'Выход',
                incomplete: 'Не завершено'
            },
            edit: {
                title: 'Редактировать запись посещаемости',
                info: 'Отредактируйте время входа и выхода. Статус будет рассчитан автоматически по графику.',
                update: 'Обновить запись'
            },
            create: {
                title: 'Создать ручную запись',
                create: 'Создать запись'
            },
            fields: {
                date: 'Дата',
                checkIn: 'Время входа',
                checkOut: 'Время выхода',
                checkOutOptional: 'Время выхода (необязательно)',
                status: 'Статус'
            },
            delete: {
                header: 'Удалить запись',
                message: 'Вы уверены, что хотите удалить эту запись посещаемости? Действие нельзя отменить.'
            },
            toasts: {
                loaded: 'Загружено записей: {count}',
                loadFailed: 'Не удалось загрузить записи',
                updated: 'Запись успешно обновлена',
                updateFailed: 'Не удалось обновить запись',
                created: 'Ручная запись создана',
                createFailed: 'Не удалось создать запись',
                deleted: 'Запись удалена',
                deleteFailed: 'Не удалось удалить запись'
            }
        }
    },
    manualRecords: {
        pageTitle: 'Управление ручными записями',
        labels: {
            worker: 'Работник',
            month: 'Месяц'
        },
        actions: {
            create: 'Создать ручную запись'
        },
        loading: 'Загрузка записей...',
        empty: 'За этот месяц записи посещаемости отсутствуют.',
        status: {
            inProgress: 'В процессе',
            checkedIn: 'Вход',
            checkedOut: 'Выход',
            incomplete: 'Не завершено'
        },
        edit: {
            title: 'Редактировать запись посещаемости',
            info: 'Отредактируйте время входа и выхода. Статус будет рассчитан автоматически по графику.',
            update: 'Обновить запись'
        },
        create: {
            title: 'Создать ручную запись',
            create: 'Создать запись'
        },
        fields: {
            date: 'Дата',
            checkIn: 'Время входа',
            checkOut: 'Время выхода',
            checkOutOptional: 'Время выхода (необязательно)',
            status: 'Статус'
        },
        delete: {
            header: 'Удалить запись',
            message: 'Вы уверены, что хотите удалить эту запись посещаемости? Действие нельзя отменить.'
        },
        toasts: {
            loaded: 'Загружено записей: {count}',
            loadFailed: 'Не удалось загрузить записи',
            updated: 'Запись успешно обновлена',
            updateFailed: 'Не удалось обновить запись',
            created: 'Ручная запись создана',
            createFailed: 'Не удалось создать запись',
            deleted: 'Запись удалена',
            deleteFailed: 'Не удалось удалить запись'
        }
    },
    components: {
        attendanceCard: {
            inProgress: 'В процессе'
        },
        geofenceCard: {
            location: 'Местоположение',
            atOffice: 'В офисе',
            outside: 'Снаружи',
            verifying: 'Проверка...',
            checking: 'Проверка местоположения...',
            youAreInside: 'На месте',
            needToBeInside: 'Нужно быть внутри для входа/выхода'
        },
        qrFeedback: {
            titles: {
                validated: 'QR-код подтверждён',
                locationFailed: 'Проверка местоположения не удалась',
                validationFailed: 'Проверка не удалась'
            },
            messages: {
                success: 'QR-код успешно подтверждён!',
                locationErrorDefault:
                    'Проверка местоположения не удалась. Оставайтесь в пределах офиса.',
                failedDefault: 'Проверка QR-кода не удалась. Повторите попытку.'
            },
            actions: {
                tryAgain: 'Повторить',
                cancel: 'Отмена'
            }
        }
    },
    notifications: {
        checkIn: {
            before: {
                title: 'Пора отметить вход',
                body: 'Не забудьте отметить вход по прибытии в офис'
            },
            after: {
                title: 'Нет отметки входа',
                body: 'Отметка входа отсутствует. Пожалуйста, сделайте это как можно скорее'
            }
        },
        checkOut: {
            before: {
                title: 'Пора отметить выход',
                body: 'Не забудьте отметить выход перед уходом из офиса'
            },
            after: {
                title: 'Нет отметки выхода',
                body: 'Отметка выхода отсутствует. Пожалуйста, сделайте это сейчас'
            }
        },
        test: {
            title: 'Тестовое уведомление',
            body: 'Это тестовое уведомление из админ-панели Warden'
        },
        settings: {
            checkInBeforeLabel: 'Напоминание о входе (до)',
            checkInBeforeDesc: 'Напоминать до начала работы',
            checkInAfterLabel: 'Напоминание о входе (после)',
            checkInAfterDesc: 'Напоминать, если я забыл отметить вход',
            checkOutBeforeLabel: 'Напоминание о выходе (до)',
            checkOutBeforeDesc: 'Напоминать до окончания работы',
            checkOutAfterLabel: 'Напоминание о выходе (после)',
            checkOutAfterDesc: 'Напоминать, если я забыл отметить выход'
        }
    },
    scannerView: {
        ui: {
            initializing: 'Инициализация сканера...',
            notSupportedTitle: 'Сканер не поддерживается',
            notSupportedMessage: 'Сканирование QR недоступно на этом устройстве.',
            verifyingLocation: 'Проверка местоположения...',
            locationRequired: 'Требуется местоположение',
            startStartingTitle: 'Запуск сканера...',
            preparingCamera: 'Подготовка камеры к распознаванию QR-кодов',
            startScanButton: 'Начать сканирование',
            verifyLocationButton: 'Проверить местоположение',
            cancel: 'Отмена',
            toggleFlashAria: 'Переключить фонарик',
            debugPrefix: 'Отладка: locationStatus = "{status}"'
        },
        alerts: {
            scannerErrorTitle: 'Ошибка сканера',
            ok: 'ОК',
            locationRequiredTitle: 'Требуется местоположение',
            locationRequiredMessage:
                'Нужно находиться в пределах офиса, чтобы сканировать QR-коды.'
        },
        toasts: {
            notSupported: 'Сканирование QR не поддерживается на этом устройстве',
            genericError: 'Ошибка сканера. Повторите попытку.'
        },
        errors: {
            timeout:
                'Время ожидания местоположения истекло. Убедитесь, что GPS включён, и повторите попытку.',
            failedOpenCamera: 'Не удалось открыть сканер камеры',
            failedScan: 'Не удалось сканировать QR-код'
        },
        location: {
            insideReady: 'Местоположение подтверждено. Готово к сканированию.',
            outsideBoundary: 'Нужно быть внутри офиса, чтобы сканировать QR-коды.',
            poorAccuracy: 'Низкая точность GPS. Перейдите на открытую местность.',
            gpsUnavailable: 'Требуется сигнал GPS. Перейдите на открытую местность.',
            permissionRequired: 'Требуется разрешение на местоположение.',
            checking: 'Проверка местоположения...',
            verificationRequired: 'Требуется проверка местоположения.'
        },
        headerTitle: 'QR-сканер'
    },
    logViewer: {
        title: 'Логи',
        search: 'Поиск логов...',
        filters: {
            title: 'Фильтры',
            active: 'Активные',
            category: 'Категория',
            level: 'Уровень',
            type: 'Тип',
            dateRange: 'Диапазон дат',
            startDate: 'Начальная дата',
            endDate: 'Конечная дата',
            clearFilters: 'Очистить фильтры'
        },
        categories: {
            all: 'Все категории',
            sync: 'Синхронизация',
            auth: 'Авторизация',
            location: 'Местоположение',
            qr: 'QR',
            ble: 'BLE',
            api: 'API',
            admin: 'Администратор',
            system: 'Система',
            security: 'Безопасность'
        },
        levels: {
            all: 'Все уровни',
            debug: 'Отладка',
            info: 'Информация',
            warn: 'Предупреждение',
            error: 'Ошибка'
        },
        securityTypes: {
            all: 'Все типы',
            invalid_qr: 'Неверный QR',
            expired_qr: 'Истёкший QR',
            replay_attempt: 'Повторная атака',
            geofence_failure: 'Ошибка геозоны',
            repeated_failure: 'Повторяющиеся ошибки'
        },
        actions: {
            export: 'Экспорт',
            clear: 'Очистить логи',
            refresh: 'Обновить',
            viewDetails: 'Показать детали',
            hideDetails: 'Скрыть детали'
        },
        states: {
            loading: 'Загрузка логов...',
            empty: 'Логи не найдены',
            emptyFiltered: 'Нет логов, соответствующих фильтрам',
            emptyActivity: 'Нет логов активности',
            emptySecurity: 'Подозрительная активность не обнаружена'
        },
        details: {
            title: 'Детали лога',
            timestamp: 'Временная метка',
            level: 'Уровень',
            category: 'Категория',
            message: 'Сообщение',
            context: 'Дополнительные детали',
            workerId: 'ID работника',
            location: 'Местоположение',
            failureReason: 'Причина ошибки',
            attemptCount: 'Попытки',
            syncStatus: 'Статус синхронизации',
            isPermanent: 'Постоянная запись'
        },
        badges: {
            suspicious: 'ПОДОЗРИТЕЛЬНЫЙ',
            permanent: 'ПОСТОЯННЫЙ'
        },
        count: {
            total: '{count} логов',
            suspicious: '{count} подозрительных'
        },
        alerts: {
            clearTitle: 'Очистить все логи',
            clearMessage: 'Вы уверены, что хотите удалить все логи? Это действие необратимо.',
            clearConfirm: 'Очистить логи',
            clearSecurityTitle: 'Очистить логи безопасности',
            clearSecurityMessage: 'Вы уверены, что хотите удалить все логи безопасности? Это действие необратимо.'
        },
        toasts: {
            exported: 'Логи успешно экспортированы',
            exportFailed: 'Не удалось экспортировать логи',
            cleared: 'Все логи были очищены',
            clearFailed: 'Не удалось очистить логи',
            refreshed: 'Логи обновлены',
            refreshFailed: 'Не удалось обновить логи'
        }
    },
    profileAssignment: {
        noUser: {
            title: 'Пользователь не установлен',
            message: 'Пожалуйста, обратитесь к администратору для настройки устройства.',
            adminAccess: 'Доступ администратора'
        },
        auth: {
            authenticating: 'Аутентификация...'
        },
        workerSelection: {
            title: 'Назначить сотрудника устройству',
            subtitle: 'Выберите сотрудника, который будет использовать это устройство',
            loading: 'Загрузка сотрудников...',
            searchPlaceholder: 'Поиск сотрудников по имени или ID...',
            workersFound: 'Найдено {count} сотрудник(ов)',
            selectedWorker: 'Выбранный сотрудник:',
            workerId: 'ID: {id}',
            noResults: 'Не найдено сотрудников, соответствующих "{query}"',
            assignButton: 'Назначить сотрудника устройству',
            selectWorker: 'Пожалуйста, выберите сотрудника'
        },
        errors: {
            connectionError: 'Невозможно подключиться к серверу. Проверьте подключение.',
            loadWorkersFailed: 'Не удалось загрузить сотрудников. Попробуйте снова.',
            invalidPassword: 'Неверный пароль администратора. Попробуйте снова.',
            authFailed: 'Аутентификация не удалась. Попробуйте снова.',
            workerNotFound: 'Сотрудник не найден. Обратитесь в IT-поддержку.',
            assignmentFailed: 'Не удалось аутентифицировать сотрудника. Попробуйте снова.'
        }
    },
    vacation: {
        title: 'Отпуск',
        summary: 'Информация об отпуске',
        paidRemaining: 'Доступно сейчас',
        perYear: 'Начисляется в год',
        atYearStart: 'На 1 января',
        unpaidUsed: 'За свой счёт',
        history: 'История',
        from: 'С',
        to: 'по',
        adjustment: 'Корректировка',
        noHistory: 'Записей не найдено',
        types: {
            VACATION: 'Отпуск',
            WORKING_HOLIDAY: 'Отгул',
            ADJUSTMENT: 'Корректировка',
        },
        d: 'дн',
        h: 'ч',
        error: 'Не удалось загрузить данные об отпуске. Попробуйте снова.',
        retry: 'Повторить'
    },
    update: {
        title: 'Доступно обновление',
        whatsNew: 'Что нового',
        updateApp: 'Обновить приложение',
        installNewVersion: 'Установить новую версию',
        later: 'Позже',
        downloadingBundle: 'Загрузка обновления...',
        downloadingApk: 'Загрузка установщика...',
        downloadFailed: 'Загрузка не удалась. Попробуйте снова.',
        apkInstallHint: 'Вам будет предложено установить обновление.',
        readyToRestart: 'Обновление загружено! Перезапустите приложение для применения новой версии.',
        restartNow: 'Перезапустить'
    }
}
